import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import IconStyles from "components/icons/Icon.module.scss";

export const Bag = ({size, fill, className, id}) => {
  let _attributes = {};
  _attributes.viewBox = "0 0 48 48";
  _attributes.width = _attributes.height = size || 48;
  if (id.trim() !== "") _attributes.id = id;
  if (className) {
    _attributes.className = classnames(IconStyles["icon"], className);
  } else {
    _attributes.className = IconStyles["icon"];
  }

  return (
    <svg {..._attributes}>
      <rect className={IconStyles["icon__canvas"]} x={"0"} y={"0"} width={"48"} height={"48"}/>
      <rect width="48" height="48" fill="none"/>
      <path d="M57.71,46,54.789,13.467A1.723,1.723,0,0,0,53.073,11.9H47.05V9.182a9.181,9.181,0,1,0-18.362,0V11.9H22.66a1.723,1.723,0,0,0-1.716,1.569L18.012,46.123A1.723,1.723,0,0,0,19.728,48H56.011a1.723,1.723,0,0,0,1.723-1.723A1.754,1.754,0,0,0,57.71,46ZM32.133,9.182a5.736,5.736,0,1,1,11.471,0V11.9H32.133ZM21.612,44.554l2.623-29.21h4.452v3.081a1.723,1.723,0,1,0,3.446,0V15.344H43.6v3.081a1.723,1.723,0,1,0,3.446,0V15.344H51.5l2.623,29.21Z" transform="translate(-14.005)" fill={fill} />
    </svg>
  );
};

Bag.defaultProps = {
  size: 48,
  fill: "#fff",
  className: "",
  id: ""
};

Bag.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  fill: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  id: PropTypes.string
};
